// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class CustomDomain {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b;
        this.id = model.id;
        this.designSystemId = model.designSystemId;
        this.supernovaDomain = model.supernovaDomain;
        this.customerDomain = (_a = model.customerDomain) !== null && _a !== void 0 ? _a : null;
        this.state = model.state;
        this.error = model.error;
        this.errorCode = (_b = model.errorCode) !== null && _b !== void 0 ? _b : null;
    }
}
